import React, { useEffect, useRef, useState } from "react";
import { CiSearch } from "react-icons/ci";
import { DatePicker } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { myLayoutActions } from "../../store/layout";
import { handleFilter } from "../../store/layout/actions";
import { FaFilter } from "react-icons/fa";
const { RangePicker } = DatePicker;

const SidebarFilter = () => {
  const { layout, category, auth } = useSelector((state) => state);
  const [searchEvent, setSearchEvent] = useState(null);
  const [selectedDate, setSelectedDate] = useState([]);
  const dispatch = useDispatch();
  const sidebarRef = useRef(null);

  const isEnableReset =
    layout?.filterByDate !== null ||
    layout?.filterBySearch !== null ||
    layout?.filterByOrganisation !== null ||
    layout?.filterByCategory !== null;

  const disablePastDates = (current) => {
    return current && current < new Date().setHours(0, 0, 0, 0);
  };

  const isEmptyArray = () => {
    return JSON.stringify(selectedDate) === JSON.stringify(["", ""]);
  };

  const handleAction = (action, value) => {
    if (action === "search" && ["", null]?.includes(value)) return;
    handleFilter(action, value)(dispatch);
  };

  const onChangDate = async (_date, dateString) => {
    setSelectedDate(dateString);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        dispatch(myLayoutActions.setIsMenuOpen(false));
      }
    };

    if (layout?.isMenuOpen) {
      document.addEventListener("pointerdown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("pointerdown", handleClickOutside);
    };
  }, [dispatch, layout?.isMenuOpen]);

  useEffect(() => {
    if (selectedDate?.length > 1 && !isEmptyArray()) {
      handleFilter(
        "date",
        `fromDate=${selectedDate[0]}&toDate=${selectedDate[1]}`
      )(dispatch);
    } else {
      dispatch(myLayoutActions.setFilterByDate(null));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, selectedDate]);

  useEffect(() => {
    if (["", null]?.includes(searchEvent)) {
      handleFilter("search", null)(dispatch);
    }
  }, [dispatch, searchEvent]);

  return (
    <aside
      ref={sidebarRef}
      className={`fixed top-0 left-0 h-full w-[85%] text-white p-6 z-40 transform transition-transform duration-2000 ease-in-out ${
        layout?.isMenuOpen
          ? "translate-x-0 mt-12 pb-32 duration-2000 bg-[#24262a] lg:bg-transparent"
          : "-translate-x-full duration-1500 mt-12 md:mt-0 bg-[#24262a] lg:bg-transparent"
      } lg:relative lg:translate-x-0 lg:w-[30%] 2xl:w-[22%] lg:h-[calc(100vh-180px)] overflow-y-auto no-scrollbar`}
    >
      <div>
        <div className="flex items-center justify-end lg:justify-between pt-2 lg:pt-5">
          <h2 className="text-xl font-bold mb-4 md:flex hidden">Search</h2>
          {isEnableReset && (
            <div className="flex items-center space-x-1 mb-4 px-2 py-1 rounded-md border border-primary">
              <FaFilter className="text-primary" />
              <button
                className="text-base font-bold "
                onClick={() => handleFilter("reset")(dispatch)}
              >
                Reset
              </button>
            </div>
          )}
        </div>
        <div className="md:flex hidden">
          <input
            type="text"
            placeholder="Search"
            className="w-full p-3 rounded-tl-xl rounded-bl-xl bg-[#333333] text-white placeholder-[#A3A3A3] outline-none"
            onChange={(e) => setSearchEvent(e.target.value)}
          />
          <button
            className="bg-primary text-white font-bold py-2 px-4 rounded-tr-xl rounded-br-xl transition-colors text-center"
            onClick={() => handleAction("search", searchEvent)}
          >
            <CiSearch />
          </button>
        </div>
        <p className="text-xs mt-2 text-[#A3A3A3] md:flex hidden">
          Results depend on active filters
        </p>
      </div>
      <div className="w-full h-[0.5px] bg-[#333333] my-6 md:flex hidden"></div>

      <div>
        <h3 className="text-lg font-semibold text-white">Date</h3>
        <div className="flex gap-2 mt-2">
          <RangePicker
            className="h-12 w-full dark:bg-[#333333] border-none dark:text-white custom-range-picker"
            disabledDate={disablePastDates}
            onChange={onChangDate}
          />
        </div>
        <p className="text-xs mt-2 text-[#A3A3A3]">Pick a date range</p>
      </div>
      <div className="w-full h-[0.5px] bg-[#333333] my-6"></div>

      <div>
        <h3 className="text-lg font-semibold text-white">Category</h3>
        <div className="flex flex-wrap gap-2 mt-2">
          {category?.all?.data?.map((category) => (
            <button
              key={category?._id}
              onClick={() => handleAction("category", category?._id)}
              className={`px-3 rounded-full h-7 text-xs capitalize text-white ${
                layout?.filterByCategory === category?._id
                  ? "bg-primary hover:bg-blue-700"
                  : "bg-[#333333]"
              }`}
            >
              {category?.name}
            </button>
          ))}
        </div>
      </div>
      <div className="w-full h-[0.5px] bg-[#333333] my-6"></div>

      <div>
        <h3 className="text-lg font-semibold text-white">Organizers</h3>
        <div className="flex flex-col gap-3 mt-2">
          {auth?.organisationData?.map((organizer, index) => (
            <div className="flex items-center gap-2" key={index}>
              <img
                src={organizer?.profile}
                alt=""
                className="w-10 h-10 object-cover xrounded-full"
              />
              <span className="text-white">{organizer?.name}</span>
            </div>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default SidebarFilter;
